import { orbCore } from 'services/Orb/Service'
import { parseCommuniques } from './Parser'
import { CommuniqueModel } from 'core/models/communique'

export const CompanyCommuniquesService = {
  list: ({ filters = [], pagination }) =>
    orbCore.companyCommuniquesDomain.list(CommuniqueModel.list({ filters, pagination })).then(parseCommuniques)
}
